import React from 'react';


export const MongoDB = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/mongo.png')} />
    )
};
